import { createAsyncThunk } from '@reduxjs/toolkit'
import { CollectionController } from 'controller/collection'
import { IEventCollectionData } from 'meta/pages/v4/eventCollection'

type Returned = IEventCollectionData[]

type Props = {
  codes: string[]
}

export const getBulkData = createAsyncThunk<Returned, Props>('pages/collection/bulk', async (props) => {
  const { codes } = props

  const data = await CollectionController.getBulkData({ codes })

  return data.items
})
